export const truncateText = (description: string, maxWords: number = 100): string => {
    if (!description) return '';
    
    const words = description.split(' ');
    if (words.length <= maxWords) return description;
    
    return words.slice(0, maxWords).join(' ') + '...';
}; 